import React from "react";
import { useState } from "react";
import ProfileModal from "./ProfileModal"; 
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Sidebar2 = ({ setIsSidebar2Open, isOpen, toggleSidebar, setAllow, allow, role }) => {
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const navigate = useNavigate();
    const handleLogout = () => {
      navigate("/");
      localStorage.removeItem("admin");
    };


  return (
    <div>
      {/* Sidebar */}
      <div
       style={{
        position: "fixed",
        top: "50px", // Positioned below the header
        right: isOpen ? "0px" : "-300px", // Slides in from the right
        width: "200px",
        height: "auto",
        backgroundColor: "#343A40",
        zIndex: 12, // Corrected: Use camelCase
        color: "#fff",
        padding: "15px",
        transition: "right 0.3s ease-in-out",
        borderRadius: "10px",
        boxShadow: "0 0 10px rgba(0,0,0,0.3)",
      }}
      
      >
       
        <ul style={{ listStyle: "none", padding: 0 }}>
        <li
            style={{ padding: "10px 0", cursor: "pointer", color: "white" }}
            onClick={() => setIsProfileOpen(true)}
          >
            Profile
        </li>

        {role === 'admin' && (
          <li
            style={{ padding: "10px 0", cursor: "pointer", color: "white" }}
            onClick={() => {setAllow(!allow); setIsSidebar2Open(false)}}
          >
            Add Chips
          </li>
        )}

        <li style={{ padding: "10px 0", cursor: "pointer" }}>
          <Link to="/admin/browse_recharge" style={{ textDecoration: "none", color: "inherit" }}>
              Pending Reaharge
          </Link>
        </li>

        <li style={{ padding: "10px 0", cursor: "pointer" }}>
          <Link to="/admin/deposit_history" style={{ textDecoration: "none", color: "inherit" }}>
              Recharge History
          </Link>
        </li>

        <li style={{ padding: "10px 0", cursor: "pointer" }}>
          <Link to="/admin/settings" style={{ textDecoration: "none", color: "inherit" }}>
              Bank
          </Link>
        </li>
         
        </ul>
        <button
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: "red",
            color: "white",
            border: "none",
            cursor: "pointer",
           
          }}
          onClick={handleLogout}
        >
          Logout
        </button>
        {/* Profile Modal */}
        <ProfileModal
          isOpen={isProfileOpen}
          onClose={() => setIsProfileOpen(false)}
        />
      </div>

    </div>
  );
};

export default Sidebar2;